// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/navigation/report-options2/simple-filter-v2/simple-filter-v2.component.css
// module id = 473
// module chunks = 0